import React from 'react';
import PropTypes from 'prop-types';

const MaxWidthContainer = ({ classes, children }) => (
  <div className={`container-fluid max-width-container-new ${classes}`}>
    {children}
  </div>
);

MaxWidthContainer.propTypes = {
  classes: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default MaxWidthContainer;



// WEBPACK FOOTER //
// ./library/app/components/Global/Containers/MaxWidthContainer.js